import React from 'react';
import { Spin, Alert } from 'antd';


const Spinner = ({text}) => (
  <div className="spinner-overlay">
    <div className="spinner-container">
      <Spin  wrapperClassName="sffsdfs" size="large">
        <Alert  message={text ?? "Please wait..."} type="info" />
      </Spin>
    </div>
  </div>
);
Spinner.defaultProps = {
  text: 'Please wait...',
};
export default Spinner;